import { useCallback, useLayoutEffect, useRef, useState } from 'react';

const themeKey = 'theme';

const defaultTheme: ThemeType = 'light';
const getDefaultTheme = (): ThemeType => {
  const fromStore = localStorage.getItem(themeKey);
  if (fromStore) {
    return fromStore === 'dark' ? 'dark' : 'light';
  }

  return defaultTheme;
};

export const useSetupTheme = () => {
  const [theme, setTheme] = useState(getDefaultTheme);
  const themeRef = useRef(theme);
  const firstLoad = useRef(true);

  const handleChange = useCallback((newTheme: ThemeType) => {
    themeRef.current = newTheme;
    localStorage.setItem(themeKey, newTheme);
    setTheme(newTheme);
  }, []);

  const handleToggle = useCallback(() => {
    const theme = themeRef.current;
    handleChange(theme === 'dark' ? 'light' : 'dark');
  }, [themeRef, handleChange]);

  useLayoutEffect(() => {
    if (firstLoad.current) {
      firstLoad.current = false;
      return;
    }

    document.documentElement.classList.add('transition-root');

    const timedOut = setTimeout(() => {
      document.documentElement.classList.remove('transition-root');
    }, 1000);

    return () => {
      clearTimeout(timedOut);
    };
  }, [theme]);

  useLayoutEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  return { theme, onChange: handleChange, onToggle: handleToggle };
};
